import { render, staticRenderFns } from "./today-list.vue?vue&type=template&id=54813cf4&scoped=true&"
import script from "./today-list.vue?vue&type=script&lang=js&"
export * from "./today-list.vue?vue&type=script&lang=js&"
import style0 from "./today-list.vue?vue&type=style&index=0&id=54813cf4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54813cf4",
  null
  
)

export default component.exports